module.exports = __webpack_public_path__ + "static/media/008-Fenster_ID_2.20c7ca61.mp3";